document.addEventListener('DOMContentLoaded', function () {
    (function (window, document) {
        let activeModalId = null;
        let isOverlayModal = false;
        let ignoreHashChange = false;
        let triggerElement = null;
        const overlayStack = [];

        // Open modal with overlay
        function openAsOverlay(modalId, trigger) {
            const modalElement = document.getElementById(modalId);
            if (!modalElement) return;

            // Save modal overlay
            overlayStack.push({
                id: modalId,
                trigger: trigger
            });

            // Add marker overlay
            isOverlayModal = true;
            document.body.classList.add('modal-overlay');

            // Add hash
            ignoreHashChange = true;
            window.location.hash = modalId;

            // Fix z-index
            setTimeout(() => {
                const backdrop = document.querySelector('.modal-backdrop:last-child');
                if (backdrop) {
                    backdrop.style.zIndex = 1055 + overlayStack.length * 2;
                }

                const modal = document.querySelector(`#${modalId}`);
                if (modal) {
                    modal.style.zIndex = 1055 + overlayStack.length * 2 + 1;
                }
            }, 10);

            const modal = window.Modal.getOrCreateInstance(modalElement);
            modal.show();
        }

        // Close modal overlay
        function closeTopOverlay() {
            if (overlayStack.length === 0) return;

            const { id } = overlayStack.pop();
            const modalElement = document.getElementById(id);
            if (modalElement) {
                const modal = window.Modal.getInstance(modalElement);
                if (modal) modal.hide();
            }

            if (overlayStack.length === 0) {
                document.body.classList.remove('modal-overlay');
            }
        }

        function isModal(element) {
            return element &&  (element.classList.contains('modal') || element.classList.contains('modal-dialog'));
        }

        // Global manager for hashchange
        window.addEventListener('hashchange', function() {

            // Prevent if we have 2 modals
            if (ignoreHashChange) {
                ignoreHashChange = false;
                return;
            }

            const hash = window.location.hash.substring(1);
            const modalElement = hash ? document.getElementById(hash) : null;

            // Cas 1: Fermer la modal principale si le hash a disparu
            if (activeModalId && !hash) {
                const activeModal = window.Modal.getInstance(document.getElementById(activeModalId));
                if (activeModal) activeModal.hide();
                return;
            }

            // Cas 2: Gérer les overlays
            const overlayIndex = overlayStack.findIndex(item => item.id === hash);
            if (overlayIndex !== -1) {
                // Si l'overlay est déjà ouvert, ne rien faire
                return;
            }

            // Cas 3: Ouvrir une nouvelle modal principale
            if (modalElement && modalElement !== document.getElementById(activeModalId)) {
                // Fermer l'ancienne modal si elle existe
                if (activeModalId) {
                    const oldModal = window.Modal.getInstance(document.getElementById(activeModalId));
                    if (oldModal) oldModal.hide();
                }

                const modal = window.Modal.getOrCreateInstance(modalElement);
                modal.show();
            }
        });

        // data-bs-modal-hash
        document.querySelectorAll('[data-bs-modal-hash]').forEach(function (link) {
            const modalTarget = link.getAttribute('data-bs-target');
            const modalId = modalTarget.substring(1);
            const modalElement = document.getElementById(modalId);

            if (!modalElement) return;

            // Event open modal
            modalElement.addEventListener('show.bs.modal', function (event) {
                // Sauvegarder l'élément déclencheur
                triggerElement = event.relatedTarget || document.activeElement;

                // Mettre à jour le hash seulement si nécessaire
                if (window.location.hash !== `#${modalId}`) {
                    ignoreHashChange = true;
                    window.location.hash = modalId;
                }

                activeModalId = modalId;
            });

            // Event close modal
            modalElement.addEventListener('hidden.bs.modal', function () {

                // Restaurer le focus si nécessaire
                if (triggerElement) {
                    triggerElement.focus();
                    triggerElement = null;
                }

                // Supprimer ?display (specific to filterModal)
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('display')) {
                    urlParams.delete('display');
                    history.replaceState(null, '', window.location.pathname + window.location.hash);
                }

                // Supprimer le hash seulement s'il correspond à cette modal
                if (window.location.hash === `#${modalId}`) {
                    ignoreHashChange = true;
                    history.pushState(null, '', window.location.pathname + window.location.search);
                }

                activeModalId = null;
            });
        });

        // Init page > auto open modal
        const initialHash = window.location.hash.substring(1);
        if (initialHash) {
            const modalElement = document.getElementById(initialHash);
            const modalScreen = modalElement.getAttribute('data-screen');
            let modalByScreenEnable = false;

            if (isModal(modalElement)) {
                const modal = window.Modal.getOrCreateInstance(modalElement);

                // Open
                if (!modalScreen) {

                    modal.show();

                // Open by screen context if we found data-screen
                } else {

                    const screens = modalScreen.split(',').map(s => s.trim());
                    for (const screen of screens) {
                        if (document.body.classList.contains(screen)) {
                            modalByScreenEnable = true;
                        }
                    }
                    if(modalScreen && modalByScreenEnable){
                        modal.show();
                    }
                }
            }
        }

        // Init overlay modal > (?step= + #hash)
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('step') !== null && window.location.hash === '#recallModal') {
            const recallButton = document.querySelector('[data-bs-target="#recallModal"][data-bs-modal-overlay]');
            openAsOverlay('recallModal', recallButton);
        }

        // Expose for vue
        window.openModalAsOverlay = openAsOverlay;
        window.closeTopOverlay = closeTopOverlay;

    })(window, document);
});
